/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PractitionerStrictHttpResponse } from '../../practitioner-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ConsumerPractitionerIdSignatureGet$Params {
  practitionerId: string;
}

export function consumerPractitionerIdSignatureGet(http: HttpClient, rootUrl: string, params: ConsumerPractitionerIdSignatureGet$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, consumerPractitionerIdSignatureGet.PATH, 'get');
  if (params) {
    rb.path('practitionerId', params.practitionerId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as PractitionerStrictHttpResponse<void>;
    })
  );
}

consumerPractitionerIdSignatureGet.PATH = '/Consumer/{practitionerId}/Signature';
